export default __webpack_public_path__ + "static/media/juice.1333f550.svg";